(function () {
  'use strict';

  if (window.WhiteWaterLinkedProducts && window.WhiteWaterLinkedProducts.initialized) return;

  var SECTION_ID = 'product';
  var SECTION_WRAPPER_ID = 'shopify-section-' + SECTION_ID;
  var CACHE_LIMIT = 20;
  var responseCache = new Map();
  var activeController = null;
  var activeTargetUrl = '';
  var requestSequence = 0;

  var controller = window.WhiteWaterLinkedProducts || {};
  controller.initialized = true;
  controller.isReplacing = false;
  window.WhiteWaterLinkedProducts = controller;

  function getWidget(root) {
    return (root || document).querySelector('[data-linked-product-swatches]');
  }

  function getStatusRegion() {
    var region = document.getElementById('LinkedProductStatus');
    if (region) return region;

    region = document.createElement('span');
    region.id = 'LinkedProductStatus';
    region.className = 'sr-only';
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    document.body.appendChild(region);
    return region;
  }

  function announce(message) {
    var region = getStatusRegion();
    region.textContent = '';
    window.requestAnimationFrame(function () {
      region.textContent = message || '';
    });
  }

  function formatMessage(template, token, value) {
    return (template || '').replace(token, value || '');
  }

  function formatSizeMessage(template, colour, size) {
    return (template || '')
      .replace('__COLOUR__', colour || '')
      .replace('__SIZE__', size || '');
  }

  function getMessages() {
    var widget = getWidget();
    return {
      loading: widget ? widget.dataset.loadingTemplate : '',
      showing: widget ? widget.dataset.showingTemplate : '',
      error: widget ? widget.dataset.errorTemplate : '',
      sizeUnavailable: widget ? widget.dataset.sizeUnavailableTemplate : '',
      soldOut: widget ? widget.dataset.soldOutLabel : ''
    };
  }

  function getSelectedSize() {
    var display = document.getElementById('SizeValueDisplay');
    return display ? display.textContent.trim() : '';
  }

  function getSizeAvailability(link) {
    try {
      return JSON.parse(link.dataset.linkedProductSizeAvailability || '{}');
    } catch (error) {
      return {};
    }
  }

  function syncAvailability(selectedSize) {
    var size = typeof selectedSize === 'string' ? selectedSize.trim() : getSelectedSize();
    var messages = getMessages();

    document.querySelectorAll('[data-linked-product-link]').forEach(function (link) {
      var availability = getSizeAvailability(link);
      var hasMatchingSize = size && Object.prototype.hasOwnProperty.call(availability, size);
      var isUnavailable = Boolean(size && (!hasMatchingSize || availability[size] !== true));
      var colour = link.dataset.linkedProductLabel || '';

      link.classList.toggle('is-unavailable', isUnavailable);
      if (isUnavailable) {
        link.dataset.selectedSizeUnavailable = 'true';
        link.dataset.tooltip = colour + (messages.soldOut ? ' (' + messages.soldOut + ')' : '');
        link.setAttribute('aria-label', formatSizeMessage(messages.sizeUnavailable, colour, size));
      } else {
        delete link.dataset.selectedSizeUnavailable;
        link.dataset.tooltip = colour;
        link.setAttribute('aria-label', link.dataset.linkedProductAvailableLabel || colour);
      }
    });

    var currentLink = document.querySelector('[data-linked-product-link][aria-current="page"]');
    var currentStatus = document.querySelector('[data-linked-product-current-status]');
    var currentIsUnavailable = Boolean(
      currentLink && currentLink.classList.contains('is-unavailable') && messages.soldOut
    );

    if (currentStatus) {
      currentStatus.hidden = !currentIsUnavailable;
      currentStatus.textContent = currentIsUnavailable ? messages.soldOut : '';
    }
  }

  controller.syncAvailability = syncAvailability;

  function cleanUrl(value) {
    var url = new URL(value, window.location.href);
    url.searchParams.delete('section_id');
    url.hash = '';
    return url;
  }

  function urlsSharePath(first, second) {
    var firstUrl = cleanUrl(first);
    var secondUrl = cleanUrl(second);
    return firstUrl.origin === secondUrl.origin && firstUrl.pathname === secondUrl.pathname;
  }

  function getTargetLabel(targetUrl) {
    var matchingLink = Array.prototype.find.call(
      document.querySelectorAll('[data-linked-product-link]'),
      function (link) {
        return urlsSharePath(link.href, targetUrl);
      }
    );
    return matchingLink ? matchingLink.dataset.linkedProductLabel : '';
  }

  function setBusy(isBusy) {
    var productSection = document.getElementById('ProductSection');
    if (!productSection) return;
    if (isBusy) {
      productSection.setAttribute('aria-busy', 'true');
    } else {
      productSection.removeAttribute('aria-busy');
    }
  }

  function addToCache(key, html) {
    if (responseCache.has(key)) responseCache.delete(key);
    responseCache.set(key, html);
    if (responseCache.size > CACHE_LIMIT) {
      responseCache.delete(responseCache.keys().next().value);
    }
  }

  function parseSection(html) {
    var parsedDocument = new DOMParser().parseFromString(html, 'text/html');
    var wrapper = parsedDocument.getElementById(SECTION_WRAPPER_ID);
    if (!wrapper) throw new Error('Linked product section wrapper is missing.');
    if (!wrapper.querySelector('#ProductSection')) throw new Error('Linked product content is missing.');
    if (!wrapper.querySelector('form[action*="/cart/add"]')) throw new Error('Linked product form is missing.');
    if (!wrapper.querySelector('h1.p-title')) throw new Error('Linked product title is missing.');
    if (!wrapper.querySelector('[data-linked-product-metadata]')) throw new Error('Linked product metadata is missing.');
    if (!wrapper.querySelector('[data-linked-product-swatches]')) throw new Error('Linked product swatches are missing.');
    return wrapper;
  }

  function readMetadata(wrapper) {
    var node = wrapper.querySelector('[data-linked-product-metadata]');
    var metadata = JSON.parse(node.textContent);
    if (!metadata.documentTitle || !metadata.canonicalUrl || !metadata.productTitle) {
      throw new Error('Linked product metadata is incomplete.');
    }
    return metadata;
  }

  function updateMetaContent(selector, content, attributeName, attributeValue) {
    if (content === null || typeof content === 'undefined') return;
    var nodes = document.querySelectorAll(selector);
    nodes.forEach(function (node) {
      node.setAttribute('content', content);
    });
    if (!nodes.length && attributeName && attributeValue) {
      var node = document.createElement('meta');
      node.setAttribute(attributeName, attributeValue);
      node.setAttribute('content', content);
      document.head.appendChild(node);
    }
  }

  function updateMetadata(metadata) {
    document.title = metadata.documentTitle;

    document.querySelectorAll('link[rel="canonical"]').forEach(function (node) {
      node.setAttribute('href', metadata.canonicalUrl);
    });

    updateMetaContent('meta[name="description"]', metadata.description, 'name', 'description');
    updateMetaContent('meta[property="og:url"]', metadata.canonicalUrl, 'property', 'og:url');
    updateMetaContent('meta[property="og:title"]', metadata.productTitle, 'property', 'og:title');
    updateMetaContent('meta[property="og:description"]', metadata.description, 'property', 'og:description');
    updateMetaContent('meta[property="og:image"]', metadata.imageHttp || metadata.image, 'property', 'og:image');
    updateMetaContent('meta[property="og:image:secure_url"]', metadata.image, 'property', 'og:image:secure_url');
    updateMetaContent('meta[property="og:price:amount"]', metadata.price, 'property', 'og:price:amount');
    updateMetaContent('meta[property="og:price:currency"]', metadata.currency, 'property', 'og:price:currency');
    updateMetaContent('meta[name="twitter:title"]', metadata.productTitle, 'name', 'twitter:title');
    updateMetaContent('meta[name="twitter:description"]', metadata.twitterDescription, 'name', 'twitter:description');
    updateMetaContent('meta[name="twitter:image"]', metadata.image, 'name', 'twitter:image');
  }

  function replayInlineScripts(wrapper) {
    wrapper.querySelectorAll('script:not([src])').forEach(function (oldScript) {
      var type = (oldScript.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'text/javascript' && type !== 'application/javascript') return;

      var newScript = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attribute) {
        newScript.setAttribute(attribute.name, attribute.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }

  function replaceProductSection(incomingWrapper, metadata, selectedSize) {
    var currentWrapper = document.getElementById(SECTION_WRAPPER_ID);
    if (!currentWrapper) throw new Error('Current product section wrapper is missing.');

    if (window.WhiteWaterProductPage && typeof window.WhiteWaterProductPage.destroy === 'function') {
      window.WhiteWaterProductPage.destroy();
    }

    var replacement = document.importNode(incomingWrapper, true);
    controller.isReplacing = true;
    currentWrapper.replaceWith(replacement);

    try {
      replayInlineScripts(replacement);
      if (!window.WhiteWaterProductPage || typeof window.WhiteWaterProductPage.init !== 'function') {
        throw new Error('Destination product initializer is missing.');
      }
      window.WhiteWaterProductPage.init();
      if (selectedSize && typeof window.WhiteWaterProductPage.selectSize === 'function') {
        window.WhiteWaterProductPage.selectSize(selectedSize);
      }
      syncAvailability(selectedSize);
      updateMetadata(metadata);
    } finally {
      controller.isReplacing = false;
    }
  }

  function focusCurrentSwatch() {
    var current = document.querySelector('[data-linked-product-link][aria-current="page"]');
    if (!current) return;
    try {
      current.focus({ preventScroll: true });
    } catch (error) {
      current.focus();
    }
  }

  async function fetchSection(targetUrl, signal) {
    var requestUrl = new URL(targetUrl.href);
    requestUrl.searchParams.set('section_id', SECTION_ID);
    if (window.Shopify && window.Shopify.country) {
      requestUrl.searchParams.set('country', window.Shopify.country);
    }
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      requestUrl.searchParams.set('currency', window.Shopify.currency.active);
    }

    var cacheKey = requestUrl.href;
    if (responseCache.has(cacheKey)) return responseCache.get(cacheKey);

    var response = await fetch(requestUrl.href, {
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      signal: signal
    });

    if (!response.ok) throw new Error('Linked product request failed with status ' + response.status + '.');
    var html = await response.text();
    if (!html.trim()) throw new Error('Linked product response is empty.');
    addToCache(cacheKey, html);
    return html;
  }

  async function navigate(target, options) {
    var targetUrl = cleanUrl(target);
    var settings = options || {};
    var targetLabel = settings.label || getTargetLabel(targetUrl) || targetUrl.pathname;
    var messages = getMessages();
    var selectedSize = settings.selectedSize || getSelectedSize();

    if (activeController && activeTargetUrl === targetUrl.href) return;

    var sequence = ++requestSequence;

    if (activeController) activeController.abort();
    activeController = new AbortController();
    activeTargetUrl = targetUrl.href;
    setBusy(true);
    announce(formatMessage(messages.loading, '__COLOUR__', targetLabel));

    try {
      var html = await fetchSection(targetUrl, activeController.signal);
      if (sequence !== requestSequence) return;

      var incomingWrapper = parseSection(html);
      var metadata = readMetadata(incomingWrapper);
      replaceProductSection(incomingWrapper, metadata, selectedSize);

      if (settings.updateHistory !== false) {
        window.history.pushState({ linkedProduct: true, url: targetUrl.href }, '', targetUrl.href);
      }

      setBusy(false);
      if (settings.focusAfterReplace) focusCurrentSwatch();
      announce(formatMessage(getMessages().showing, '__PRODUCT__', metadata.productTitle));

      document.dispatchEvent(new CustomEvent('linked-product:change', {
        detail: {
          url: targetUrl.href,
          productTitle: metadata.productTitle
        }
      }));
    } catch (error) {
      if (error && error.name === 'AbortError') return;
      if (sequence !== requestSequence) return;
      setBusy(false);
      announce(formatMessage(messages.error, '__COLOUR__', targetLabel));
      window.location.assign(targetUrl.href);
    } finally {
      if (sequence === requestSequence) {
        activeController = null;
        activeTargetUrl = '';
      }
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-linked-product-link]');
    if (!link) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.origin !== window.location.origin) return;

    event.preventDefault();
    if (link.getAttribute('aria-current') === 'page') return;

    navigate(link.href, {
      label: link.dataset.linkedProductLabel,
      focusAfterReplace: event.detail === 0,
      updateHistory: true
    });
  });

  window.addEventListener('popstate', function () {
    if (!getWidget()) return;
    navigate(window.location.href, {
      label: getTargetLabel(window.location.href),
      focusAfterReplace: false,
      updateHistory: false
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAvailability();
    }, { once: true });
  } else {
    syncAvailability();
  }
})();
